import React, { createContext, useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const AppContext = createContext();

const hexToRgb = (hex) => {
  if (!hex || typeof hex !== 'string') return '255 255 255';
  let h = hex.replace('#', '');
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return isNaN(r) ? '255 255 255' : `${r} ${g} ${b}`;
};

const defaultTextStyles = {
  navHome: { text: 'HOME', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  navRosters: { text: 'ROSTERS', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  navSchedule: { text: 'PROGRAMMA', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  navGallery: { text: 'GALLERY', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  navRules: { text: 'REGOLAMENTO', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  navGuests: { text: 'GUESTS', color: '#ffffff', sizeMobile: '1.2rem', sizeDesktop: '1.1rem', visible: true, align: 'center' },
  eventTitle: { text: 'LA IANNATA 2026', color: '#ffffff', sizeMobile: '4rem', sizeDesktop: '10rem', visible: true, align: 'center' },
  scoreboardTitle: { text: 'Punteggio Generale', color: 'rgba(255,255,255,0.3)', sizeMobile: '1.2rem', sizeDesktop: '1.8rem', visible: true, align: 'center' },
  partialsTitle: { text: 'RISULTATI PARZIALI', color: 'rgba(255,255,255,0.4)', sizeMobile: '1.2rem', sizeDesktop: '1.5rem', visible: true, align: 'center' },
  athletesTitle: { text: 'The Athletes', color: '#ffffff', sizeMobile: '2.5rem', sizeDesktop: '4rem', visible: true, align: 'center' },
  homeEventsTitle: { text: 'Highlights & Match', color: '#ffffff', sizeMobile: '2.5rem', sizeDesktop: '4rem', visible: true, align: 'center' },
  rostersTitle: { text: 'OFFICIAL_ROSTERS', color: '#ffffff', sizeMobile: '3.5rem', sizeDesktop: '8rem', visible: true, align: 'left' },
  scheduleTitle: { text: 'PROGRAMMA', color: '#ffffff', sizeMobile: '3.5rem', sizeDesktop: '8rem', visible: true, align: 'left' },
  galleryTitle: { text: 'EVENT GALLERY', color: '#ffffff', sizeMobile: '3.5rem', sizeDesktop: '8rem', visible: true, align: 'left' },
  rulesTitle: { text: 'REGOLAMENTO', color: '#ffffff', sizeMobile: '3.5rem', sizeDesktop: '8rem', visible: true, align: 'left' },
  guestsTitle: { text: 'SPECIAL GUESTS', color: '#ffffff', sizeMobile: '3.5rem', sizeDesktop: '8rem', visible: true, align: 'left' },
  footerTitle: { text: "IANNATA SERIES '26", color: '#ffffff', sizeMobile: '2rem', sizeDesktop: '3rem', visible: true, align: 'left' },
  footerSub1: { text: "Developed for the community", color: 'rgba(255,255,255,0.4)', sizeMobile: '0.9rem', sizeDesktop: '1.1rem', visible: true, align: 'right' },
  footerSub2: { text: "© 2026 Official League", color: 'rgba(255,255,255,0.4)', sizeMobile: '0.9rem', sizeDesktop: '1.1rem', visible: true, align: 'right' }
};

export const AppProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showCountdown, setShowCountdown] = useState(true);
  const [showBadge, setShowBadge] = useState(true);
  const [showRules, setShowRules] = useState(true);
  const [showGuests, setShowGuests] = useState(true);
  const [eventDate, setEventDate] = useState('2026-06-12T21:00');
  const [badgeText, setBadgeText] = useState('LIVE SERIES 2026');
  const [pageTitle, setPageTitle] = useState('IANNATA 2026 | PRO LEAGUE');

  const [badgeGap, setBadgeGap] = useState(2.5);
  const [gapBadgeTitle, setGapBadgeTitle] = useState(4);
  const [gapHeroTitleCountdown, setGapHeroTitleCountdown] = useState(2);
  const [scoreboardGap, setScoreboardGap] = useState(8);
  const [gapScoreTitleBoxes, setGapScoreTitleBoxes] = useState(4);
  const [gapScoreBoxNameScore, setGapScoreBoxNameScore] = useState(1);
  const [gapBoxesPartials, setGapBoxesPartials] = useState(2);
  const [gapPartialsTitleList, setGapPartialsTitleList] = useState(1.5);
  const [gapScoresRoster, setGapScoresRoster] = useState(8);
  const [gapTitleTeams, setGapTitleTeams] = useState(5);
  const [gapTeamHeaderLine, setGapTeamHeaderLine] = useState(1.5);
  const [gapTeamLineCaptain, setGapTeamLineCaptain] = useState(2.5);
  const [gapTeamCaptainGrid, setGapTeamCaptainGrid] = useState(2.5);
  const [gapRosterEvents, setGapRosterEvents] = useState(8);
  const [gapEventsTitleGrid, setGapEventsTitleGrid] = useState(4);
  const [gapDayTitleEvents, setGapDayTitleEvents] = useState(2);
  const [gapEventsList, setGapEventsList] = useState(1);
  const [gapCaptainRoster, setGapCaptainRoster] = useState(3);

  const [textStyles, setTextStyles] = useState(defaultTextStyles);
  const [teams, setTeams] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [globalScores, setGlobalScores] = useState({ t1: 0, t2: 0 });
  const [gallery, setGallery] = useState([]);
  const [gallerySections, setGallerySections] = useState([]);
  const [rules, setRules] = useState([]);
  const [guests, setGuests] = useState([]);

  useEffect(() => { document.title = pageTitle; }, [pageTitle]);

  useEffect(() => {
    fetchData();
    supabase.auth.getSession().then(({ data: { session } }) => setIsAdmin(!!session));
    const { data: authListener } = supabase.auth.onAuthStateChange((_, session) => setIsAdmin(!!session));
    return () => authListener.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (teams[0]?.color) document.documentElement.style.setProperty('--alpha-color', hexToRgb(teams[0].color));
    if (teams[1]?.color) document.documentElement.style.setProperty('--omega-color', hexToRgb(teams[1].color));
  }, [teams]);

  const fetchData = async () => {
    try {
      const { data: config } = await supabase.from('config_v1').select('*').single();
      if (config) {
        setShowCountdown(config.show_countdown !== false);
        if (config.show_badge !== undefined && config.show_badge !== null) setShowBadge(config.show_badge);
        if (config.show_rules !== undefined && config.show_rules !== null) setShowRules(config.show_rules);
        if (config.show_guests !== undefined && config.show_guests !== null) setShowGuests(config.show_guests);
        setEventDate(config.event_date || '2026-06-12T21:00');
        setBadgeText(config.badge_text || 'LIVE SERIES 2026');
        if (config.page_title !== undefined && config.page_title !== null) setPageTitle(config.page_title);
        
        if (config.badge_gap !== undefined && config.badge_gap !== null) setBadgeGap(Number(config.badge_gap));
        if (config.gap_badge_title !== undefined && config.gap_badge_title !== null) setGapBadgeTitle(Number(config.gap_badge_title));
        if (config.gap_hero_title_countdown !== undefined && config.gap_hero_title_countdown !== null) setGapHeroTitleCountdown(Number(config.gap_hero_title_countdown));
        if (config.scoreboard_gap !== undefined && config.scoreboard_gap !== null) setScoreboardGap(Number(config.scoreboard_gap));
        if (config.gap_score_title_boxes !== undefined && config.gap_score_title_boxes !== null) setGapScoreTitleBoxes(Number(config.gap_score_title_boxes));
        if (config.gap_score_box_name_score !== undefined && config.gap_score_box_name_score !== null) setGapScoreBoxNameScore(Number(config.gap_score_box_name_score));
        if (config.gap_boxes_partials !== undefined && config.gap_boxes_partials !== null) setGapBoxesPartials(Number(config.gap_boxes_partials));
        if (config.gap_partials_title_list !== undefined && config.gap_partials_title_list !== null) setGapPartialsTitleList(Number(config.gap_partials_title_list));
        if (config.gap_scores_roster !== undefined && config.gap_scores_roster !== null) setGapScoresRoster(Number(config.gap_scores_roster));
        if (config.gap_title_teams !== undefined && config.gap_title_teams !== null) setGapTitleTeams(Number(config.gap_title_teams));
        if (config.gap_team_header_line !== undefined && config.gap_team_header_line !== null) setGapTeamHeaderLine(Number(config.gap_team_header_line));
        if (config.gap_team_line_captain !== undefined && config.gap_team_line_captain !== null) setGapTeamLineCaptain(Number(config.gap_team_line_captain));
        if (config.gap_team_captain_grid !== undefined && config.gap_team_captain_grid !== null) setGapTeamCaptainGrid(Number(config.gap_team_captain_grid));
        if (config.gap_roster_events !== undefined && config.gap_roster_events !== null) setGapRosterEvents(Number(config.gap_roster_events));
        if (config.gap_events_title_grid !== undefined && config.gap_events_title_grid !== null) setGapEventsTitleGrid(Number(config.gap_events_title_grid));
        if (config.gap_day_title_events !== undefined && config.gap_day_title_events !== null) setGapDayTitleEvents(Number(config.gap_day_title_events));
        if (config.gap_events_list !== undefined && config.gap_events_list !== null) setGapEventsList(Number(config.gap_events_list));
        if (config.gap_captain_roster !== undefined && config.gap_captain_roster !== null) setGapCaptainRoster(Number(config.gap_captain_roster));
        
        if (config.text_styles) {
          const merged = { ...defaultTextStyles };
          Object.keys(config.text_styles).forEach(k => {
            merged[k] = { ...merged[k], ...config.text_styles[k] };
          });
          setTextStyles(merged);
        }
        
        if (config.gallery_sections) {
          let parsedSections = config.gallery_sections;
          if (typeof parsedSections === 'string') {
            try { parsedSections = JSON.parse(parsedSections); } catch (e) { parsedSections = []; }
          }
          setGallerySections(Array.isArray(parsedSections) ? parsedSections : []);
        } else {
          setGallerySections([]);
        }
        
        setGlobalScores({ t1: config.global_score_t1 || 0, t2: config.global_score_t2 || 0 });
      }

      const { data: teamsData } = await supabase.from('teams_v1').select('*').order('id');
      if (teamsData) setTeams(teamsData);

      const { data: scheduleData, error: scheduleError } = await supabase.from('schedule_v1').select('*').order('day_number').order('time');
      if (scheduleError) console.error("Errore fetch schedule:", scheduleError);
      
      if (scheduleData) {
        const grouped = scheduleData.reduce((acc, act) => {
          if (!acc[act.day_number]) acc[act.day_number] = [];
          acc[act.day_number].push({
            ...act,
            address: act.address || act.location || '',
            notes: act.notes || act.description || '',
            scoreT1: act.score_t_1 || act.score_t1,
            scoreT2: act.score_t_2 || act.score_t2,
            counts_towards_score: act.counts_towards_score !== false
          });
          return acc;
        }, {});
        setSchedule(grouped);
      }

      const { data: galleryData } = await supabase.from('gallery_v1').select('*').order('created_at', { ascending: false });
      if (galleryData) {
        const normalizedGallery = galleryData.map((item) => {
          const mediaUrl = (item.url || item.image_url || '').trim();
          return { ...item, url: mediaUrl, image_url: item.image_url || mediaUrl };
        });
        setGallery(normalizedGallery);
      }

      const { data: rulesData } = await supabase.from('rules_v1').select('*').order('order_index');
      if (rulesData) setRules(rulesData);

      const { data: guestsData } = await supabase.from('guests_v1').select('*').order('order_index');
      if (guestsData) setGuests(guestsData);

    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const syncConfig = async (updates) => {
    const { data: config } = await supabase.from('config_v1').select('id').single();
    if (config) {
      let { error } = await supabase.from('config_v1').update(updates).eq('id', config.id);
      if (error && error.message && error.message.includes('column')) {
        const safeUpdates = { ...updates };
        const newFields = [
          'badge_text', 'badge_gap', 'scoreboard_gap', 'gap_badge_title', 'gap_scores_roster', 'gap_title_teams', 
          'gap_roster_events', 'gap_captain_roster', 'gap_hero_title_countdown', 'gap_score_title_boxes', 
          'gap_boxes_partials', 'gap_team_header_line', 'gap_team_line_captain', 'gap_team_captain_grid', 
          'gap_events_title_grid', 'gap_score_box_name_score', 'gap_partials_title_list', 'gap_day_title_events', 
          'gap_events_list', 'text_styles', 'page_title', 'event_date', 'show_badge', 'show_rules', 'show_guests', 
          'gallery_sections', 'global_score_t1', 'global_score_t2'
        ];
        newFields.forEach(f => delete safeUpdates[f]);
        if (Object.keys(safeUpdates).length > 0) {
          await supabase.from('config_v1').update(safeUpdates).eq('id', config.id);
        }
      }
    }
  };

  return (
    <AppContext.Provider value={{
      isAdmin, loading, textStyles, teams, schedule, globalScores, gallery, gallerySections, rules, guests,
      showCountdown, showBadge, showRules, showGuests, eventDate, badgeText, pageTitle,
      badgeGap, gapBadgeTitle, gapHeroTitleCountdown, scoreboardGap, gapScoreTitleBoxes, gapScoreBoxNameScore,
      gapBoxesPartials, gapPartialsTitleList, gapScoresRoster, gapTitleTeams, gapTeamHeaderLine,
      gapTeamLineCaptain, gapTeamCaptainGrid, gapRosterEvents, gapEventsTitleGrid, gapDayTitleEvents,
      gapEventsList, gapCaptainRoster,
      login: async (e, p) => {
        const { error } = await supabase.auth.signInWithPassword({ email: e, password: p });
        if (error) throw error;
        return true;
      },
      logout: () => supabase.auth.signOut(),
      updateConfig: (updates) => {
        if (updates.show_countdown !== undefined) setShowCountdown(updates.show_countdown);
        if (updates.show_badge !== undefined) setShowBadge(updates.show_badge);
        if (updates.show_rules !== undefined) setShowRules(updates.show_rules);
        if (updates.show_guests !== undefined) setShowGuests(updates.show_guests);
        if (updates.event_date !== undefined) setEventDate(updates.event_date);
        if (updates.badge_text !== undefined) setBadgeText(updates.badge_text);
        if (updates.page_title !== undefined) setPageTitle(updates.page_title);
        
        if (updates.badge_gap !== undefined) setBadgeGap(Number(updates.badge_gap));
        if (updates.gap_badge_title !== undefined) setGapBadgeTitle(Number(updates.gap_badge_title));
        if (updates.gap_hero_title_countdown !== undefined) setGapHeroTitleCountdown(Number(updates.gap_hero_title_countdown));
        if (updates.scoreboard_gap !== undefined) setScoreboardGap(Number(updates.scoreboard_gap));
        if (updates.gap_score_title_boxes !== undefined) setGapScoreTitleBoxes(Number(updates.gap_score_title_boxes));
        if (updates.gap_score_box_name_score !== undefined) setGapScoreBoxNameScore(Number(updates.gap_score_box_name_score));
        if (updates.gap_boxes_partials !== undefined) setGapBoxesPartials(Number(updates.gap_boxes_partials));
        if (updates.gap_partials_title_list !== undefined) setGapPartialsTitleList(Number(updates.gap_partials_title_list));
        if (updates.gap_scores_roster !== undefined) setGapScoresRoster(Number(updates.gap_scores_roster));
        if (updates.gap_title_teams !== undefined) setGapTitleTeams(Number(updates.gap_title_teams));
        if (updates.gap_team_header_line !== undefined) setGapTeamHeaderLine(Number(updates.gap_team_header_line));
        if (updates.gap_team_line_captain !== undefined) setGapTeamLineCaptain(Number(updates.gap_team_line_captain));
        if (updates.gap_team_captain_grid !== undefined) setGapTeamCaptainGrid(Number(updates.gap_team_captain_grid));
        if (updates.gap_roster_events !== undefined) setGapRosterEvents(Number(updates.gap_roster_events));
        if (updates.gap_events_title_grid !== undefined) setGapEventsTitleGrid(Number(updates.gap_events_title_grid));
        if (updates.gap_day_title_events !== undefined) setGapDayTitleEvents(Number(updates.gap_day_title_events));
        if (updates.gap_events_list !== undefined) setGapEventsList(Number(updates.gap_events_list));
        if (updates.gap_captain_roster !== undefined) setGapCaptainRoster(Number(updates.gap_captain_roster));
        
        if (updates.gallery_sections !== undefined) setGallerySections(updates.gallery_sections);
        syncConfig(updates);
      },
      updateTextStyle: (key, field, value) => {
        const updated = { ...textStyles, [key]: { ...(textStyles[key] || defaultTextStyles[key]), [field]: value } };
        setTextStyles(updated);
        syncConfig({ text_styles: updated });
      },
      updateTeam: async (id, up) => {
        setTeams(prev => prev.map(t => t.id === id ? { ...t, ...up } : t));
        let { error } = await supabase.from('teams_v1').update(up).eq('id', id);
        if (error && error.message && error.message.includes('column')) {
          const safeUp = { ...up };
          delete safeUp.division;
          delete safeUp.description;
          if(Object.keys(safeUp).length > 0) {
            await supabase.from('teams_v1').update(safeUp).eq('id', id);
          }
        }
      },
      updateGlobalScores: (t1, t2) => {
        const newScores = { t1: Number(t1), t2: Number(t2) };
        setGlobalScores(newScores);
        syncConfig({ global_score_t1: newScores.t1, global_score_t2: newScores.t2 });
      },
      addActivity: async (act) => {
        try {
          const newPayload = {
            day_number: Number(act.day), title: act.title, time: act.time, address: act.address, notes: act.notes,
            score_t1: 0, score_t2: 0, counts_towards_score: act.counts_towards_score, status: act.status || 'upcoming'
          };
          if (act.event_date) newPayload.event_date = act.event_date;
          
          const { error } = await supabase.from('schedule_v1').insert([newPayload]);
          if (error) {
            console.error("Supabase Insert Error:", error);
            if (error.code === 'PGRST204' || error.message?.includes('column')) {
              const legacyPayload = { ...newPayload };
              delete legacyPayload.counts_towards_score;
              delete legacyPayload.status;
              await supabase.from('schedule_v1').insert([legacyPayload]);
            } else {
              alert("Errore salvataggio evento: " + error.message);
            }
          }
        } catch (err) {
          alert("Errore di sistema durante il salvataggio: " + err.message);
        } finally {
          fetchData();
        }
      },
      updateActivity: async (aid, act) => {
        try {
          const payload = {
            day_number: Number(act.day), title: act.title, time: act.time, address: act.address, notes: act.notes,
            event_date: act.event_date, counts_towards_score: act.counts_towards_score, status: act.status
          };
          const { error } = await supabase.from('schedule_v1').update(payload).eq('id', aid);
          if (error) throw error;
        } catch (err) {
          alert("Errore aggiornamento evento: " + err.message);
        } finally {
          fetchData();
        }
      },
      updateScore: async (aid, s1, s2) => {
        const { error } = await supabase.from('schedule_v1').update({ score_t1: Number(s1), score_t2: Number(s2) }).eq('id', aid);
        if (error) alert("Errore aggiornamento punteggio: " + error.message);
        fetchData();
      },
      updateActivityStatus: async (aid, status) => {
        const { error } = await supabase.from('schedule_v1').update({ status }).eq('id', aid);
        if (error) alert("Errore aggiornamento stato: " + error.message);
        fetchData();
      },
      deleteActivity: async (aid) => {
        const { error } = await supabase.from('schedule_v1').delete().eq('id', aid);
        if (error) alert("Errore eliminazione evento: " + error.message);
        fetchData();
      },
      updateGallerySections: (updatedSections) => {
        setGallerySections(updatedSections);
        syncConfig({ gallery_sections: updatedSections });
      },
      addGallerySection: (section) => {
        const updated = [...(gallerySections || []), section];
        setGallerySections(updated);
        syncConfig({ gallery_sections: updated });
      },
      deleteGallerySection: (sectionId) => {
        const updated = (gallerySections || []).filter(s => s.id !== sectionId && s.parentId !== sectionId);
        setGallerySections(updated);
        syncConfig({ gallery_sections: updated });
      },
      addMediaBulk: async (urls, type, parentId = '') => {
        const sanitizedUrls = (urls || []).map(u => (u || '').trim()).filter(Boolean);
        if (sanitizedUrls.length === 0) {
          alert('Inserisci almeno un URL valido');
          return;
        }
        const section = gallerySections.find(s => s.id === parentId);
        const payload = sanitizedUrls.map((mediaUrl) => ({
          image_url: mediaUrl, url: mediaUrl, type, title: 'Untitled Media', parentId: parentId || null,
          section_title: section ? section.title : '', section_order: section ? section.order : 0
        }));
        const { error } = await supabase.from('gallery_v1').insert(payload);
        if (error) alert("Errore caricamento media: " + error.message);
        fetchData();
      },
      deleteMedia: async (id) => {
        const { error } = await supabase.from('gallery_v1').delete().eq('id', id);
        if (error) alert("Errore eliminazione media: " + error.message);
        fetchData();
      },
      updateGallerySectionTitle: async (sectionId, oldTitle, newTitle) => {
        const updatedSections = (gallerySections || []).map(s => s.id === sectionId ? { ...s, title: newTitle } : s);
        syncConfig({ gallery_sections: updatedSections });
        setGallerySections(updatedSections);
        const { error } = await supabase.from('gallery_v1').update({ section_title: newTitle }).eq('section_title', oldTitle);
        if (error) console.error("Errore update media fallback title", error);
        fetchData();
      },
      addRule: async (rule) => {
        const newOrder = rules.length > 0 ? Math.max(...rules.map(r => r.order_index || 0)) + 1 : 1;
        const { error } = await supabase.from('rules_v1').insert([{ ...rule, order_index: newOrder }]);
        if (error) alert("Errore creazione regola: " + error.message);
        fetchData();
      },
      updateRule: async (id, ruleUpdates) => {
        const { error } = await supabase.from('rules_v1').update(ruleUpdates).eq('id', id);
        if (error) alert("Errore aggiornamento regola: " + error.message);
        fetchData();
      },
      deleteRule: async (id) => {
        const { error } = await supabase.from('rules_v1').delete().eq('id', id);
        if (error) alert("Errore eliminazione regola: " + error.message);
        fetchData();
      },
      addGuest: async (guest) => {
        const newOrder = guests.length > 0 ? Math.max(...guests.map(g => g.order_index || 0)) + 1 : 1;
        const { error } = await supabase.from('guests_v1').insert([{ ...guest, order_index: newOrder }]);
        if (error) alert("Errore creazione guest: " + error.message);
        fetchData();
      },
      updateGuest: async (id, guestUpdates) => {
        const { error } = await supabase.from('guests_v1').update(guestUpdates).eq('id', id);
        if (error) alert("Errore aggiornamento guest: " + error.message);
        fetchData();
      },
      deleteGuest: async (id) => {
        const { error } = await supabase.from('guests_v1').delete().eq('id', id);
        if (error) alert("Errore eliminazione guest: " + error.message);
        fetchData();
      },
      getTotalScores: () => globalScores,
      RenderName: ({ name, className = "" }) => <span className={`team-name-render ${className}`} dangerouslySetInnerHTML={{ __html: name || '' }} />,
      formatDate: (d) => d ? new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' }).toUpperCase() : '',
      formatDateDDMMYYYY: (d) => {
        if (!d) return '';
        const parts = d.split('-');
        if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
        return d;
      }
    }}>
      <style>
        {Object.entries(textStyles).map(([key, s]) => `
          .dyn-${key} {
            color: ${s.color} !important;
            font-size: ${s.sizeMobile} !important;
            text-align: ${s.align || 'center'} !important;
            ${s.visible === false ? 'display: none !important;' : ''}
          }
          @media (min-width: 1024px) {
            .dyn-${key} {
              font-size: ${s.sizeDesktop} !important;
            }
          }
        `).join('\n')}
      </style>
      {children}
    </AppContext.Provider>
  );
};